import React, { useCallback } from "react";
import { Form, Image } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import { AssistanceApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./AssistanceForm.form";
import "./AssistanceForm.scss";

// 1. IMPORTAMOS NUESTRO NUEVO EDITOR
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";

const assistanceController = new AssistanceApi();

export function AssistanceForm(props) {
  const { accessToken } = useAuth();
  const { onClose, onReload, assistance } = props;

  const formik = useFormik({
    initialValues: initialValues(assistance),
    validationSchema: validationSchema(),
    validateOnChange: false,

    onSubmit: async (formValue) => {
      //console.log(formValue);
      //console.log(assistance);

      try {
        if (assistance) {
          await assistanceController.updateAssistance(
            accessToken,
            assistance._id,
            formValue,
          );
        } else {
          await assistanceController.createAssistance(accessToken, formValue);
        }

        onReload();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("miniature", URL.createObjectURL(file));
          formik.setFieldValue("file", file);
        } else {
          console.log("Tipo de archivo no soportado:", file.type);
        }
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    onDrop,
    multiple: false,
  });

  const getMiniature = () => {
    if (formik.values.file) {
      //console.log("formik.values.miniature", formik.values.miniature);
      return formik.values.miniature;
    } else if (formik.values.miniature) {
      //console.log("ENV.BASE_PATH", ENV.BASE_PATH, formik.values.miniature);
      return `${formik.values.miniature}`;
    }
    return null;
  };
  //console.log(`Miniature path: ${formik.values.miniature}`);

  return (
    <div>
      <Form className="assistance-form" onSubmit={formik.handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            name="title"
            placeholder="Titulo del curso"
            onChange={formik.handleChange}
            value={formik.values.title}
            error={formik.errors.title}
          />
          <Form.Input
            name="path"
            placeholder="Nombre del asistente"
            onChange={formik.handleChange}
            value={formik.values.path}
            error={formik.errors.path}
          />
        </Form.Group>

        <TiptapEditor
          content={formik.values.content}
          onChange={(newContent) => formik.setFieldValue("content", newContent)}
        />

        <div className="assistance-form__miniature" {...getRootProps()}>
          <input {...getInputProps()} />
          {getMiniature() ? (
            <Image size="small" src={getMiniature()} />
          ) : (
            <div>
              <span> Arrastra la imagen del Avatar </span>
            </div>
          )}
        </div>

        {/*
          Chat publico. Sin marcar, este asistente NO se puede usar sin iniciar
          sesion: `POST /threadPublic/:id` devuelve 404.

          Antes valia cualquier id, asi que bastaba con conocer -o probar- el de
          un asistente interno para usar su chat gratis. Cada conversacion es una
          llamada a un modelo de pago.

          Cerrado por defecto a proposito: marcar de mas es regalar consumo, y
          marcar de menos solo rompe un enlace que se arregla aqui en un clic.
        */}
        <Form.Checkbox
          name="isPublic"
          label="Chat publico: se puede usar sin iniciar sesion (consume IA de pago)"
          checked={formik.values.isPublic}
          onChange={(e, { checked }) =>
            formik.setFieldValue("isPublic", checked)
          }
          style={{ margin: "12px 0" }}
        />

        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          {assistance ? "Actualizar assistance" : "Crear assistance"}
        </Form.Button>
      </Form>
    </div>
  );
}
